// @core/api/endpoints/secret/get_database_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DatabaseRoleResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get database role
 * Returns a database role definition.
 */
export async function GetDatabaseRole(
  engine_id: string,
  role_name: string,
  options?: RequestOptions
): Promise<DatabaseRoleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/database/roles/:role_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':role_name', encodeURIComponent(role_name));
  const requestOptions = options;
  return client.get<DatabaseRoleResponse>(requestPath, { ...requestOptions });
}
